import { render, staticRenderFns } from "./PaymentOrderHeader.vue?vue&type=template&id=700bda06&scoped=true&lang=pug&"
import script from "./PaymentOrderHeader.vue?vue&type=script&lang=js&"
export * from "./PaymentOrderHeader.vue?vue&type=script&lang=js&"
import style0 from "./PaymentOrderHeader.vue?vue&type=style&index=0&id=700bda06&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "700bda06",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
